/**
 * DeleteCategoryConfirmationModal - Tipo 1: Modal de Confirmación
 *
 * Usa el componente global ConfirmationModal para confirmar eliminación de categoría/parámetro.
 */

import React from 'react';
import { Delete as DeleteIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ConfirmationModal } from '../../ui/Modal';

export interface DeleteCategoryConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName: string;
  itemCode?: string;
  isLoading?: boolean;
}

const DeleteCategoryConfirmationModal: React.FC<DeleteCategoryConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  itemName,
  itemCode,
  isLoading = false,
}) => {
  const customContent = (
    <Box
      sx={(theme) => ({
        mt: 2,
        p: 3,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? alpha(theme.palette.common.white, 0.06)
            : theme.palette.grey[50],
        borderRadius: '8px',
        border: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, mb: 1 }}>
        Advertencia:
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
        Si el elemento está en uso por un producto, la eliminación fallará.
      </Typography>
    </Box>
  );

  const title = itemCode
    ? `¿Eliminar "${itemName}" (Código: ${itemCode})?`
    : `¿Eliminar "${itemName}"?`;

  return (
    <ConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      confirmText={isLoading ? 'Eliminando...' : 'Eliminar'}
      cancelText="Cancelar"
      variant="danger"
      icon={<DeleteIcon />}
      loading={isLoading}
      customContent={customContent}
    />
  );
};

export default DeleteCategoryConfirmationModal;
